import axiosInstance from "./axiosInstance";

const getUserNotifications = async (page = 1, limit = 20) => {
  const response = await axiosInstance.get("notifications", { params: { page, limit } });
  return response.data;
};

const getAdminNotifications = async (page = 1, limit = 20) => {
  const response = await axiosInstance.get("notifications/admin", { params: { page, limit } });
  return response.data;
};

const readNotification = async (id: string) => {
  const response = await axiosInstance.patch(`notifications/${id}/read`);
  return response.data;
};

const readMultipleNotifications = async (ids: string[]) => {
  const response = await axiosInstance.patch("notifications/bulk/read", { ids });
  return response.data;
};

const deleteNotification = async (id: string) => {
  const response = await axiosInstance.delete(`notifications/${id}`);
  return response.data;
};

const deleteMultipleNotifications = async (ids: string[]) => {
  const response = await axiosInstance.delete("notifications/bulk", { data: { ids } });
  return response.data;
};

const getNotificationsByRole = async (roleCode?: string) => {
  const normalizedRole = (roleCode || "").toUpperCase();
  const isAdmin =
    normalizedRole === "ADMIN" ||
    normalizedRole === "REVIEWER" ||
    normalizedRole === "SUPERADMIN" ||
    normalizedRole === "SUPER_ADMIN";

  const response = await axiosInstance.get(isAdmin ? "notifications/admin" : "notifications");
  return response.data;
};

export const notificationService = {
  getUserNotifications,
  getAdminNotifications,
  readNotification,
  readMultipleNotifications,
  deleteNotification,
  deleteMultipleNotifications,
  getNotificationsByRole,
};
